var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ClickAwayListener, InputAdornment, TextField, Tooltip, } from '@mui/material';
import { cn } from 'hx-util';
import { EargoButton } from '@/components/eargo-button.component';
export function ShareLink(_a) {
    var referralLink = _a.referralLink;
    var _b = useState(false), isCopied = _b[0], setIsCopied = _b[1];
    function handleCopy() {
        if (!referralLink)
            return;
        setIsCopied(true);
        navigator.clipboard.writeText(referralLink);
    }
    function handleClose() {
        setIsCopied(false);
    }
    return (_jsx(TextField, { value: referralLink, placeholder: referralLink, variant: "outlined", color: "primary", className: "pr-0", sx: {
            border: '2px solid #3364d9',
            borderRadius: '12px',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '& input': {
                'text-overflow': 'ellipsis',
            },
        }, disabled: !referralLink, InputProps: {
            readOnly: true,
            id: 'copy-link-input',
            style: {
                paddingRight: 0,
                borderRadius: '8px',
                overflow: 'hidden',
            },
            endAdornment: (_jsx(ClickAwayListener, __assign({ onClickAway: handleClose }, { children: _jsx(Tooltip, __assign({ disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, title: "Copied to clipboard", open: isCopied, onClose: handleClose }, { children: _jsx(InputAdornment, __assign({ position: "end", className: cn('bg-primary py-7', {
                            'cursor-pointer': referralLink,
                        }), onClick: handleCopy }, { children: _jsx(EargoButton, __assign({ onClick: handleCopy, className: "text-white", disabled: !referralLink }, { children: "Copy" })) })) })) }))),
        } }));
}
